import {
  SitesBuilderLibComponent,
  Logo,
  SitesBuilderLibService,
  Viewerconfig,
  Favicon,
} from '@3ddv/ngx-sites-builder-lib';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';
import { SblibService } from '../../services/sblib.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sbeditor-tool-favicon',
  templateUrl: './favicon.component.html',
  styleUrls: ['../logo/logo.component.scss'],
})
export class FaviconComponent implements OnInit, OnDestroy {
  public tool: Favicon;
  public faviconPreview: string | ArrayBuffer = '/assets/img/3ddv/favicon-3ddv.png';
  private subscriptions: Array<Subscription>;
  private client: string;
  public default: boolean = true;

  @Output() exportTool = new EventEmitter<Logo>();

  constructor(
    private toastr: ToastrService,
    private sblibService: SblibService,
    private activatedRoute: ActivatedRoute,
    private toolsService: ToolsService
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.logo) {
        this.tool = Object.assign({}, res.logo);
        this.client = null;
        if (this.activatedRoute.snapshot.data.site?.site.title) {
          this.client = this.activatedRoute.snapshot.data.site.site.title;
        }

        if (this.tool.file) {
          this.loadPreviewImg(this.tool.file);
        } else if (this.tool.path && this.client) {
          this.loadPreviewFromPath();
        }
      } else {
        console.error('Logo tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private loadPreviewFromPath() {
    this.faviconPreview =
      environment.sitesBuilder.staticrsc_cdn +
      this.client +
      this.activatedRoute.snapshot.data.site.master.toolsConfig.favicon.path;
    this.tool.default = false;
    this.tool.path = this.activatedRoute.snapshot.data.site.master.toolsConfig.favicon.path;
    /*     const sblibReady$ = this.sblibService.getSblibReady$().subscribe(res=>{
      const viewReady$ = this.sblibService.sblib?.viewerIsReady$().subscribe(viewerConfig=>{
        this.faviconPreview = viewerConfig.cdn_staticsrsc+this.client+this.activatedRoute.snapshot.data.site.master.toolsConfig.favicon.path;
        this.tool.path = this.activatedRoute.snapshot.data.site.master.toolsConfig.logo.path;
      });
      this.subscriptions.push(viewReady$);
    });
    this.subscriptions.push(sblibReady$); */
  }

  public onFileDropped($event) {
    if (
      ($event[0].type == '' && $event[0].size == 0) ||
      ($event[0].type != 'image/jpeg' && $event[0].type != 'image/png')
    ) {
      this.toastr.error('', 'Formato del fichero inválido');
      return;
    }
    this.tool.file = $event[0];
    this.loadPreviewImg($event[0]);
  }

  public deleteDroppedFile() {
    this.tool.file = null;

    // this.logoPreview = null;
    this.faviconPreview = null;
    this.tool.path = '';
  }

  public onFileSelected($event) {
    if (
      ($event.target.files[0].type == '' && $event.target.files[0].size == 0) ||
      ($event.target.files[0].type != 'image/jpeg' && $event.target.files[0].type != 'image/png')
    ) {
      this.toastr.error('', 'Formato del fichero inválido');
      return;
    }
    this.tool.file = $event.target.files[0];
    this.loadPreviewImg($event.target.files[0]);
  }

  public loadPreviewImg(file) {
    let ext = file.name.split('.').pop();
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = _event => {
      this.faviconPreview = reader.result;
      this.tool.path = '/latest/img/favicon.' + ext;
    };
  }

  public checkDefault() {
    if (this.tool.default) {
      this.tool.path = '';
      this.faviconPreview = '/assets/img/3ddv/favicon-3ddv.png';
    } else {
      let d = this.activatedRoute.snapshot.data;
      if (this.tool.file) {
        this.loadPreviewImg(this.tool.file);
      } else if (d.site && d.master) {
        this.loadPreviewFromPath();
      }
    }
  }

  public getTool() {
    if (this.tool.default) {
      this.tool.file = null;
    }
    return this.tool;
  }
}
